import { render } from "./newTMbulkImport.vue?vue&type=template&id=dc0e63a2&scoped=true"
import script from "./newTMbulkImport.vue?vue&type=script&lang=js"
export * from "./newTMbulkImport.vue?vue&type=script&lang=js"

import "./newTMbulkImport.vue?vue&type=style&index=0&id=dc0e63a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0e63a2"]])

export default __exports__